import { useDraft } from "@/components/itsm-config/draft-context";
import { upsertRuleField } from "@/lib/itsm-config/general-mapping";
import type {
  GeneralMappingRule,
  GeneralMatch,
} from "@/lib/types/itsm-config";

/**
 * Shared editor for the general_mapping cards (priority / status / inbound /
 * custom fields). Each card patches ONE field on the rule for a given scope
 * `match`; other fields on that rule and other rules are preserved via
 * `upsertRuleField`. Writes into the page draft — persistence happens on the
 * page-level Save.
 */
export function useGeneralMappingSave() {
  const { update } = useDraft();
  return (
    match: GeneralMatch,
    patch: Partial<Omit<GeneralMappingRule, "match">>,
  ) => {
    update((current) => ({
      general_mapping: upsertRuleField(current.general_mapping, match, patch),
    }));
  };
}
